import { call, takeLatest, put } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { fetchGoalMetrics } from 'api/IterableGoalsAPI';
import { Saga } from 'custom-types/saga';
import { CompletionsVsSendsAction, QueryData } from 'modules/iterableGoals/types';
import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import { getCommonTranslations } from 'utils/translations';
import * as actions from '../actions';
import { ActionTypes } from '../actionTypes';

export function* fetchCompletionsVsSendsSaga({
  queryData,
}: CompletionsVsSendsAction<{ queryData: QueryData }>): Saga<CompletionsVsSendsAction> {
  try {
    const metricsResponse = yield call(fetchGoalMetrics, queryData);
    yield put(actions.fetchCompletionsVsSendsResponse(metricsResponse.data));
  } catch (error) {
    const errorMessage = yield call(getCommonTranslations, 'errorMessage.contactCSM');

    yield put(actions.fetchCompletionsVsSendsError());
    yield put(
      addNegativeToast(
        errorMessage,
        errorIdentifier({
          source: 'fetchCompletionsVsSendsSaga',
          error,
          additional: queryData,
        }),
      ) as any,
    );
  }
}

addToRootSaga([
  takeLatest(ActionTypes.FETCH_COMPLETIONS_VS_SENDS_METRICS_REQUEST, fetchCompletionsVsSendsSaga),
]);
